import { Container, Header } from '@cloudscape-design/components';

interface ConfigPreviewProps {
  configId: string;
  configName: string;
  configType: string;
  formValues: Record<string, unknown>;
}

/**
 * Read-only live JSON preview panel showing the resulting ConfigurationObject
 * as the user fills in the form. Updates in real time.
 *
 * Requirements: 3.9
 */
export function ConfigPreview({ configId, configName, configType, formValues }: ConfigPreviewProps) {
  const { _rawPayload, ...payloadFields } = formValues;

  let payload: Record<string, unknown>;
  if (typeof _rawPayload === 'string') {
    try {
      payload = JSON.parse(_rawPayload);
    } catch {
      payload = {};
    }
  } else {
    payload = payloadFields;
  }

  const preview = {
    configId: configId || '(not set)',
    configName: configName || '(not set)',
    configType: configType || '(not set)',
    payload,
  };

  const formatted = JSON.stringify(preview, null, 2);

  return (
    <Container header={<Header variant="h3">Preview</Header>}>
      <pre
        style={{
          backgroundColor: '#f8f9fa',
          padding: '12px',
          borderRadius: '4px',
          overflow: 'auto',
          maxHeight: '400px',
          fontSize: '12px',
          fontFamily: 'IBM Plex Mono, monospace',
          lineHeight: 1.5,
          margin: 0,
        }}
      >
        {formatted}
      </pre>
    </Container>
  );
}
